const BRAZE_VIEW_VIDEO_EVENT = 'view_video';
const BRAZE_FREE_TRIAL_START_EVENT = 'free_trial_start';
const BRAZE_CONTENT_PAGE_VIEW_EVENT = 'page_view';
const PROFILE_MANAGER_BASE_PATH = '/user-profile/';

import Braze from 'shared/Braze';
import { IAMPendingStatus } from 'shared/inAppMessagingTemp';

function onViewVideo(showName = '', episodeName = '') {
    if (CBS.Registry.Features.braze_sdk !== true || !CBS.Braze) return false;

    if (CBS.Registry.user.profile_type !== 'ADULT') {
        return;
    }

    CBS.Braze.braze.logCustomEvent(BRAZE_VIEW_VIDEO_EVENT, {
        show: showName,
        episode: episodeName,
    });
}

function onFreeTrialStart() {
    new Braze();

    if (CBS.Registry.Features.braze_sdk !== true || !CBS.Braze) return false;

    const brazeObj = CBS.Braze.brazeObj;
    let eventTrigger = () => {
        CBS.Braze.braze.logCustomEvent(BRAZE_FREE_TRIAL_START_EVENT, {});
    };

    if (!brazeObj.isInitialized()) {
        brazeObj.setOnInit(eventTrigger);
    } else {
        eventTrigger();
    }
}

function onSearchPageView(name = '/search', params = {}) {
    _triggerPageViewEvent(name, params);
}

function onNewsPageView(name = '/news', params = {}) {
    _triggerPageViewEvent(name, params);
}

function myListPageView(name = '/my-list', params = {}) {
    _triggerPageViewEvent(name, params);
}

function onLiveTvPageView(name = '/live-tv', params = {}) {
    _triggerPageViewEvent(name, params);
}

function brandsPageView(name = '/brands', params = {}) {
    _triggerPageViewEvent(name, params);
}

function onHomePageView(name = '/', params = {}) {
    _triggerPageViewEvent(name, params);
}

function onAccountPageView(name = '/account', params = {}) {
    _triggerPageViewEvent(name, params);
}

function onShowMoviePageView(name = '', params) {
    _triggerPageViewEvent(name, params);
}

function onBrowsePageView(category = '', params) {
    _triggerPageViewEvent(category, params);
}

function _triggerPageViewEvent(name = '', params = {}) {
    if (CBS.Registry.Features.braze_sdk !== true) return false;
    // check if another IAM is set to display
    if (CBS.Registry.IAM && CBS.Registry.IAM === IAMPendingStatus) {
        setTimeout(_triggerPageViewEvent, 10, name, params);
    } else if (typeof CBS.Registry.IAM === 'undefined' || CBS.Registry.IAM === '') {
        // safe to display Braze
        CBS.Registry.IAM = window.location.pathname;
        // wait for Braze to init
        let _trigger = setInterval(() => {
            if (CBS.Braze) {
                _triggerEvent(name, params);
                clearInterval(_trigger);
            }
        }, 200);
    } else {
        // another IAM is already displayed, do not display Braze
        return false;
    }
}

function _triggerEvent(name = '', params = {}) {
    const path = window.location.pathname;
    const brazeObj = CBS.Braze.brazeObj;
    // Event base properties
    const properties = {
        name: name,
        path: path,
        platform: 'Web',
    };

    if (CBS.Registry.Features.braze_sdk !== true || !CBS.Braze) return false;

    if (CBS.Registry.user.profile_type !== 'ADULT') {
        return;
    }

    // Prevent custom events log when in profile manager
    if (path.includes(PROFILE_MANAGER_BASE_PATH)) {
        return;
    }

    let eventTrigger = () => {
        CBS.Braze.braze.logCustomEvent(BRAZE_CONTENT_PAGE_VIEW_EVENT, {
            ...properties,
            ...params,
        });
    };

    if (!brazeObj.isInitialized()) {
        brazeObj.setOnInit(eventTrigger);
    } else {
        eventTrigger();
    }
}

export {
    onViewVideo,
    onFreeTrialStart,
    onSearchPageView,
    myListPageView,
    onNewsPageView,
    onLiveTvPageView,
    brandsPageView,
    onHomePageView,
    onShowMoviePageView,
    onBrowsePageView,
    onAccountPageView,
};
